module.exports = __webpack_public_path__ + "img/candy_ball_1.630bc722.png";